import React from "react";
import { formatTimeDiff } from "../tools";
import { StatType } from "../tools/stats";
import Tooltip from "../common/Tooltip";
import IconInfo from "../common/IconInfo";

import "./Stat.css";

interface Props {
    type: StatType;
    timeValue: number;
}

const info: Partial<{ [key in StatType]: { name: string; desc: string } }> = {};
info[StatType.MAX] = { name: "Max", desc: "Longest time task spent in selected statuses" };
info[StatType.SUM] = { name: "Sum", desc: "Sum of times tasks spent in selected statuses" };
info[StatType.MEAN] = { name: "Average", desc: "Mean time tasks spent in selected statuses" };
info[StatType.MEDIAN] = { name: "Median", desc: "Median (50th percentile) time tasks spent in selected statuses" };
info[StatType.STDEV] = {
    name: "Standard Deviation",
    desc: "The higher the standard deviation the bigger variation of times relative to average"
};
info[StatType.P80] = { name: "80th Percentile", desc: "80% of tasks spent less than this in selected statuses" };
info[StatType.P90] = { name: "90th Percentile", desc: "90% of tasks spent less than this in selected statuses" };

const Stat: React.FC<Props> = function ({ type, timeValue }: Props) {
    const i = info[type]!;
    return (
        <div className="stat">
            <div className="stat__title">
                <span className="text">{i.name}</span>
                <Tooltip className="stat__title__tooltip" text={i.desc}>
                    <IconInfo />
                </Tooltip>
            </div>
            <div className="stat__value">
                {timeValue !== undefined && !isNaN(timeValue) ? formatTimeDiff(timeValue, true) : "-"}
            </div>
        </div>
    );
}

export default Stat;
